import { SNACKBAR_OPEN, SNACKBAR_CLOSE } from 'types/actions/snack-bar'

const snackBarInitialState = {
  open: false,
  message: 'There was an error',
  autoHideDuration: 3000
}

export default (state = snackBarInitialState, action) => {
  switch (action.type) {
    case SNACKBAR_OPEN:
    case SNACKBAR_CLOSE:
      delete action.type
      return {
        ...state,
        ...action
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/snack-bar.js